/*
 * ELTANE — Newsletter welcome email
 *
 * The newsletter form (sections/eltane-newsletter.liquid) is a native
 * Shopify {% form 'customer' %} — submitting it adds the visitor to the
 * store's own customer list, exactly as it always has. This file does NOT
 * touch that: no preventDefault, no interception. It only fires an
 * additional, parallel request to the Flask recommendation API's
 * POST /api/newsletter-welcome so a welcome email goes out too, using the
 * same SMTP setup already wired up for the fuel plan / back-in-stock emails.
 *
 * keepalive: true matters here specifically — the native form submit
 * navigates the page away almost immediately, and without it the browser
 * would likely abort this fetch mid-flight before it ever reaches the server.
 */
(function () {
  'use strict';

  function init(root) {
    (root || document).querySelectorAll('[data-newsletter-welcome]').forEach(function (formEl) {
      if (formEl.dataset.welcomeBound === 'true') return;
      formEl.dataset.welcomeBound = 'true';

      var apiBase = (formEl.getAttribute('data-api-base') || '').replace(/\/+$/, '');
      var apiSecretKey = formEl.getAttribute('data-api-secret-key') || '';
      var emailInput = formEl.querySelector('input[type="email"]');

      formEl.addEventListener('submit', function () {
        if (!apiBase || !emailInput) return;
        var email = emailInput.value.trim();
        if (!email) return;

        var headers = { 'Content-Type': 'application/json' };
        if (apiSecretKey) headers['X-Api-Key'] = apiSecretKey;

        window
          .fetch(apiBase + '/api/newsletter-welcome', {
            method: 'POST',
            mode: 'cors',
            keepalive: true,
            headers: headers,
            body: JSON.stringify({ email: email })
          })
          .catch(function () {
            /* The page navigates away right after this either way (native
               form submit) — there is nothing left on screen to report a
               failure to. */
          });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
